const PLAN_LABELS = {
  FREE: 'Free',
  PREMIUM: 'Premium',
  ULTRA: 'Ultra',
};

export function normalizePlanKey(plan) {
  const key = typeof plan === 'string' ? plan.toUpperCase() : 'FREE';
  return PLAN_LABELS[key] ? key : 'FREE';
}

export function getPlanLabel(plan) {
  return PLAN_LABELS[normalizePlanKey(plan)];
}

export function isPlanCurrent(expiresAt, now = Date.now()) {
  if (!expiresAt) return true;
  const expiryTime = new Date(expiresAt).getTime();
  return Number.isFinite(expiryTime) && expiryTime > now;
}

export function resolveActivePlanKey({ subscription = null, user = null, fallback = 'FREE' } = {}) {
  if (
    subscription?.plan &&
    String(subscription.status || 'ACTIVE').toUpperCase() === 'ACTIVE' &&
    isPlanCurrent(subscription.expiresAt)
  ) {
    return normalizePlanKey(subscription.plan);
  }
  if (user?.plan && isPlanCurrent(user.planExpiresAt)) return normalizePlanKey(user.plan);
  return normalizePlanKey(fallback);
}

export function resolveCreditsTotal({ credits = null, user = null, fallback = 0 } = {}) {
  const directTotal = Number(credits?.total);
  if (Number.isFinite(directTotal)) return directTotal;

  const creditsMonthly = Number(credits?.monthly);
  const creditsExtra = Number(credits?.extra);
  if (Number.isFinite(creditsMonthly) || Number.isFinite(creditsExtra)) {
    return (Number.isFinite(creditsMonthly) ? creditsMonthly : 0) +
      (Number.isFinite(creditsExtra) ? creditsExtra : 0);
  }

  const userTotal = Number(user?.creditsTotal ?? user?.credits);
  if (Number.isFinite(userTotal)) return userTotal;

  const userMonthly = Number(user?.creditsMonthly);
  const userExtra = Number(user?.creditsExtra);
  if (Number.isFinite(userMonthly) || Number.isFinite(userExtra)) {
    return (Number.isFinite(userMonthly) ? userMonthly : 0) +
      (Number.isFinite(userExtra) ? userExtra : 0);
  }

  const fallbackTotal = Number(fallback);
  return Number.isFinite(fallbackTotal) ? fallbackTotal : 0;
}
